import type StatisticsStrapi from "~/libs/interfaces/StatisticsStrapi";
import type StatisticsLocal from "~/libs/interfaces/StatisticsLocal";

const statisticsLocalFactory = {
  createStatisticsFromStrapi(stats?: StatisticsStrapi): StatisticsLocal | undefined {
    if (!stats) {
      return undefined;
    }
    return {
      todayPrize: stats.todayPrize,
      totalPrize: stats.totalPrize,
      userTotalPrize: stats.userTotalPrize,
    }
  }
}
export default statisticsLocalFactory